module.exports = __webpack_public_path__ + "static/img/jianzhu_hangye.4cbc2042.png";